export default __webpack_public_path__ + "static/jiri-sevcik-749ee8666f1dbaa040e645cb194ab05f.jpg";